import { TemplateResult, html, CSSResultGroup } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement } from 'lit/decorators.js';
import componentStyles from './idb-form-alt.css.lit';
import { OutlineElement } from 'src/components/base/outline-element/outline-element';
import { LightDomStyles } from '../../controllers/light-dom-styles';

@customElement('idb-form-alt')
export class IdbFormAlt extends OutlineElement {
  lightDomStyles = new LightDomStyles(this, componentStyles);
  static styles: CSSResultGroup = [componentStyles];

  firstUpdated() {
    if (this.shadowRoot) {
      const forms = this.shadowRoot
        .querySelector('slot')!
        .assignedNodes()
        .filter(e => (<Element>e).tagName === 'FORM');

      forms.forEach(form => {
        const selects = (<Element>form).querySelectorAll('select');

        selects.forEach(select => {
          if (select.hasAttribute('data-drupal-facet')) {
            select.onchange = function () {
              const url =
                select.selectedOptions[0].getAttribute('data-drupal-url') || '';

              window.location.href = url;
            };
          }
        });
      });
    }
  }

  render(): TemplateResult {
    const classes = {
      'idb-form-alt': true,
    };

    return html`
    <div class=${classMap(classes)}>
      <slot></slot>
    </div>`;
  }
}
